module.exports = __webpack_public_path__ + "cb3ac3b4a8540f50937a86af7eb4663c.woff2";